module.exports = __webpack_public_path__ + "static/logo-quickbase-light-df27907effe25f37cd403a56ecb698a8.svg";